import { ReferenceCitationNode, SerializedReferenceCitationNode } from 'modules/Lexical/nodes/ReferenceCitationNode';
import * as Models from 'models';
import { DraftEntityData } from '../types';
import { getFormateCode, convertTextStyles } from '../utils';

export function createReferenceCitationNode(
  entityData: DraftEntityData,
  fonts?: Models.BrandFontsList,
): SerializedReferenceCitationNode {
  const { text, data, styles } = entityData;

  // ReferenceCitationSeparators will be created automatically on component mount
  return {
    type: ReferenceCitationNode.getType(),
    mode: 'token',
    referenceId: data?.id ?? '',
    text,
    format: getFormateCode(styles),
    style: convertTextStyles(styles, fonts),
    detail: 0,
    version: 1,
  };
}
